import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getProjects } from '../../services/projectService';

export default function CommunityProjects({ tenantId, tenantSlug }) {
  const [state, setState] = useState({ loading: true, projects: [], error: '' });
  const [revision, setRevision] = useState(0);
  useEffect(() => {
    let current = true;
    if (!tenantId) {
      setState({ loading: false, projects: [], error: 'Select a community to view projects.' });
      return () => { current = false; };
    }
    setState({ loading: true, projects: [], error: '' });
    getProjects(tenantId)
      .then(({ data }) => { if (current) setState({ loading: false, projects: data, error: '' }); })
      .catch((err) => {
        if (current) setState({ loading: false, projects: [],
          error: err.response?.data?.message || 'Unable to load community projects. Please retry.' });
      });
    return () => { current = false; };
  }, [tenantId, revision]);
  return (
    <section aria-label="Community projects">
      <h2>Projects</h2>
      {state.loading ? <p>Loading projects...</p> : state.error ? (
        <div role="alert"><p>{state.error}</p><button onClick={() => setRevision((value) => value + 1)}>Retry projects</button></div>
      ) : state.projects.length === 0 ? <p>No projects yet for this community.</p> : (
        <ul className="item-list">{state.projects.map((project) => (
          <li key={project._id}>
            <Link to={tenantSlug ? `/t/${tenantSlug}/projects/${project._id}` : `/projects/${project._id}`}>{project.title}</Link>
            <span className="badge">{project.type}</span>
            <span className="badge badge-gray">{project.status}</span>
          </li>
        ))}</ul>
      )}
    </section>
  );
}
